import { AuthState } from "../../models/AuthState";
import {
  FETCH_BALANCE_SUCCESS,
  FETCH_BALANCE_FAILED,
  LOGIN_SUCCESS,
  LOGIN_FAILED,
  AUTH_REQUEST_START,
  AUTH_REQUEST_END,
  LOG_OUT,
  LOG_OUT_SUCCESS,
  MAIL_VERIFIED_REQUEST_SUCCESS,
  MAIL_VERIFIED_REQUEST_FAILED,
  SET_OPERATOR_ID,
  SET_PARTNER_ID,
  SET_PROVIDER_ID,
  SET_SAP_TOKEN,
  SET_JWT_TOKEN,
  SET_GRID_VIEW,
  SET_LOADER_SUCCESS,
  SET_LOBBY_TYPE,
} from "./authActionTypes";

type Action = {
  type: string;
  payload: any;
};

const initialState: AuthState = {
  grid: false,
  balance: 0,
  jwtToken: null,
  sapToken: null,
  operatorId: null,
  providerId: null,
  partnerId: null,
  primaryColor: null,
  secoundaryColor: null,
  loading: false,
  loggedIn: sessionStorage.getItem("jwt_token") ? true : false,
  lobbyType: sessionStorage.getItem("lobbyType")
    ? sessionStorage.getItem("lobbyType")
    : "lobby",
};

const authReducer = (state = initialState, action: Action): AuthState => {
  switch (action.type) {
    case SET_JWT_TOKEN:
      return {
        ...state,
        jwtToken: action.payload,
      };

    case SET_LOBBY_TYPE:
      return {
        ...state,
        lobbyType: action.payload,
      };
    case SET_SAP_TOKEN:
      return {
        ...state,
        sapToken: action.payload,
      };
    case SET_OPERATOR_ID:
      return {
        ...state,
        operatorId: action.payload,
      };
    case SET_PARTNER_ID:
      return {
        ...state,
        partnerId: action.payload,
      };
    case SET_PROVIDER_ID:
      return {
        ...state,
        providerId: action.payload,
      };
    case SET_GRID_VIEW:
      return {
        ...state,
        grid: action.payload,
      };
    case SET_LOADER_SUCCESS:
      return {
        ...state,
        loading: action.payload,
      };
    // case LOG_OUT:
    //   return {
    //     ...state,
    //     loggedIn: false,
    //     loading: false,
    //   };
    // case LOG_OUT_SUCCESS:
    //   return {
    //     ...state,
    //     loggedIn: false,
    //     loading: false,
    //   };

    // case FETCH_BALANCE_SUCCESS:
    //   return {
    //     ...state,
    //   };

    // case FETCH_BALANCE_FAILED:
    //   return {
    //     ...state,
    //   };

    // case MAIL_VERIFIED_REQUEST_SUCCESS:
    //   return {
    //     ...state,
    //   };

    // case MAIL_VERIFIED_REQUEST_FAILED:
    //   return {
    //     ...state,
    //   };

    default:
      return state;
  }
};

export default authReducer;
